import Api, {urls} from '../../services/api'
import {ApiResponseList, ApiResponseType, SortingType, UserManagementType} from './types'
import logException from '../../services/sentry'
import showNotification from '../../functions/notification'
import {userManagementActions} from '../slices'
import {AppDispatch} from '..'
import {UserManagementUpdateRequestType} from '../../container/userManagement/type'
import {apiErrorBlock} from '../../functions/utils'

export const getUserManagementList = (params: SortingType) => async (dispatch: AppDispatch) => {
  try {
    const {page} = params
    const response: ApiResponseList<UserManagementType[]> = await Api.get(
      `${urls.userManagement}?page=${page}${params.sort_by ? `&sort_by=${params.sort_by}` : ''}${
        params.sort_order ? `&sort_order=${params.sort_order}` : ''
      }${params.per_page && params.per_page > 0 ? `&per_page=${params.per_page}` : ''}`,
    )
    const {status, message, data} = response.data
    if (status && data?.data) {
      await dispatch(
        userManagementActions.updateUserManagementList({
          userManagementList: data.data,
          total: data.total || 0,
          from: data.from || 0,
        }),
      )
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
  } catch (e: any) {
    apiErrorBlock(e)
  }
}

export const addUserManagement = (params: FormData) => async (dispatch: AppDispatch) => {
  try {
    const response: ApiResponseList<UserManagementType[]> = await Api.post(
      `${urls.userManagement}`,
      params,
    )
    const {status, message} = response.data
    if (status && message) {
      if (message) showNotification({title: 'Success', message, type: 'success'})
      await dispatch(getUserManagementList({page: 1}))
      return true
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
    return false
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const updateUserManagement =
  (id: number, params: UserManagementUpdateRequestType) => async (dispatch: AppDispatch) => {
    try {
      const response: ApiResponseList<UserManagementType[]> = await Api.patch(
        `${urls.userManagement}/${id}`,
        params,
      )
      const {status, message} = response.data
      if (status && message) {
        if (message) showNotification({title: 'Success', message, type: 'success'})
        await dispatch(getUserManagementList({page: 1}))
        return true
      }
      logException(new Error(message))
      if (message) showNotification({title: 'Error', message, type: 'danger'})
      return false
    } catch (e: any) {
      apiErrorBlock(e)
      return false
    }
  }

export const getUserManagementDetail = (id: number) => async (dispatch: AppDispatch) => {
  try {
    const response: ApiResponseType<UserManagementType> = await Api.get(
      `${urls.userManagement}/${id}`,
    )
    const {status, message, data} = response.data
    if (status && data) {
      await dispatch(userManagementActions.updateUserManagementDetail({userManagementDetail: data}))
      return true
    }
    logException(new Error(message))
    if (message) showNotification({title: 'Error', message, type: 'danger'})
    return false
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const clearUserManagementDetail = () => async (dispatch: AppDispatch) => {
  try {
    await dispatch(userManagementActions.clearUserManagementDetail())
    return true
  } catch (e: any) {
    apiErrorBlock(e)
    return false
  }
}
export const deleteUserManagement =
  (id: number, options: SortingType) => async (dispatch: AppDispatch) => {
    try {
      const response: ApiResponseList<UserManagementType[]> = await Api.delete(
        `${urls.userManagement}/${id}`,
      )
      const {status, message} = response.data
      if (status && message) {
        if (message) showNotification({title: 'Success', message, type: 'success'})
        await dispatch(getUserManagementList(options))
        return true
      }
      logException(new Error(message))
      if (message) showNotification({title: 'Error', message, type: 'danger'})
      return false
    } catch (e: any) {
      apiErrorBlock(e)
      return false
    }
  }
